<template>
  <img :key="logoKey" :src="source" :class="{ 'site-logo--default-header': isDefaultHeader }" @error="useDefault">
</template>
<script>
import { siteLogoUrl } from './reference';

const HEADER_LOGO = '/img/header-logo.png';
const AUTH_LOGO = '/img/homenavlogo.png';

export default {
  name: 'SiteLogo',
  props: {
    placement: { type: String, default: 'header', validator: value => ['header', 'auth'].includes(value) }
  },
  data: () => ({ failed: false }),
  computed: {
    configuredUrl() {
      const settings = this.$store.state.baseInfo || {};
      // Header artwork is independent from the existing login logo setting.
      return siteLogoUrl(this.placement === 'auth' ? settings.ico : settings.header_logo);
    },
    logoKey() { return this.placement + ':' + this.configuredUrl; },
    defaultUrl() { return this.placement === 'auth' ? AUTH_LOGO : HEADER_LOGO; },
    source() {
      return !this.failed && this.configuredUrl ? this.configuredUrl : this.defaultUrl;
    },
    isDefaultHeader() { return this.placement === 'header' && this.source === HEADER_LOGO; }
  },
  watch: {
    logoKey() { this.failed = false; }
  },
  methods: {
    useDefault() { this.failed = true; }
  }
};
</script>
